import React from 'react';
import { FadeIn, Section } from './ui/Section';
import { Button } from './ui/Button';
import { ShieldCheck, ArrowRight } from 'lucide-react';
export function PricingSection() {
  return <Section id="pricing" background="cream" data-id="element-52">
      <div className="max-w-xl mx-auto" data-id="element-53">
        <FadeIn className="bg-white rounded-3xl shadow-2xl overflow-hidden border border-[#E8E2D9]" data-id="element-54">
          <div className="bg-[#4A3728] text-[#FAF7F2] p-4 text-center text-sm font-medium tracking-wide" data-id="element-55">
            OFERTA ESPECIAL DE LANZAMIENTO
          </div>

          <div className="p-8 md:p-12 text-center" data-id="element-56">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#4A3728] mb-2" data-id="element-57">
              Plan Antipánico
            </h2>
            <p className="text-[#8C7B70] mb-8" data-id="element-58">
              La Matriz 3x3 + Scripts + Plantillas
            </p>

            <div className="flex items-center justify-center mb-2" data-id="element-59">
              <span className="text-2xl font-serif text-[#8C7B70] line-through mr-3" data-id="element-60">
                $19
              </span>
              <span className="text-6xl font-serif font-bold text-[#C4956A]" data-id="element-61">
                $6.39
              </span>
              <span className="text-[#8C7B70] ml-2 text-lg" data-id="element-62">USD</span>
            </div>

            <div className="mb-8" data-id="element-63">
              <span className="inline-block bg-[#C4956A]/15 text-[#A87B55] text-sm font-bold px-4 py-1.5 rounded-full" data-id="element-64">
                🔥 66% de descuento — solo por hoy
              </span>
            </div>

            <Button fullWidth className="mb-6 text-lg group" onClick={() => window.open('https://www.calmin3x3.com/cart/53895111901468:1', '_blank')} data-id="element-65">
              Descargar Ahora
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-66" />
            </Button>

            <p className="text-sm text-[#6B5D52] mb-8" data-id="element-67">
              Descarga inmediata. Pago seguro.
            </p>

            <div className="bg-[#FAF7F2] rounded-xl p-4 flex items-start text-left" data-id="element-68">
              <ShieldCheck className="w-6 h-6 text-[#C4956A] mr-3 flex-shrink-0 mt-0.5" data-id="element-69" />
              <div data-id="element-70">
                <h4 className="font-bold text-[#4A3728] text-sm mb-1" data-id="element-71">
                  Garantía de 7 días
                </h4>
                <p className="text-xs text-[#6B5D52]" data-id="element-72">
                  Si en 7 días no te ayudó a crear un plan claro, pídeme
                  reembolso. Sin preguntas.
                </p>
              </div>
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} className="mt-12 text-center space-y-2" data-id="element-73">
          <p className="text-[#4A3728] font-serif italic text-xl" data-id="element-74">
            "Paz financiera operativa: hoy, no 'algún día'."
          </p>
        </FadeIn>
      </div>
    </Section>;
}